import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  MassOsItineraryPaymentState
} from 'src/entities/file';

@Component({
  selector: 'app-mass-os-itinerary-sync-card',
  templateUrl: './mass-os-itinerary-sync-card.component.html',
  styleUrls: ['./mass-os-itinerary-sync-card.component.css']
})
export class MassOsItinerarySyncCardComponent {
  @Input() state!: MassOsItineraryPaymentState;
  @Input() step = 0;

  @Output() massDateChange = new EventEmitter<Date | null>();
  @Output() massCodeChange = new EventEmitter<string>();
  @Output() serviceDateChange = new EventEmitter<{
    serviceId: string;
    date: Date | null;
    ticketId?: string | null;
  }>();
  @Output() serviceCodeChange = new EventEmitter<{
    serviceId: string;
    code: string;
    ticketId?: string | null;
  }>();

  expanded = false;

  toggle(): void {
    this.expanded = !this.expanded;
  }

  onMassDateChange(date: Date | null): void {
    this.massDateChange.emit(date);
  }

  onMassCodeChange(code: string): void {
    this.massCodeChange.emit(code);
  }

  onServiceDateChange(event: {
    serviceId: string;
    date: Date | null;
    ticketId?: string | null;
  }): void {
    this.serviceDateChange.emit(event);
  }

  onServiceCodeChange(event: {
    serviceId: string;
    code: string;
    ticketId?: string | null;
  }): void {
    this.serviceCodeChange.emit(event);
  }
}
